module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currentIntegration.label))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }, [_c('div', {
    staticClass: "bg-blue-pale p-2"
  }, [_vm._v("\n                Please note: This integration is exclusively available for OTAs that use the OCTO standard.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 pb-4"
  }, [_c('div', {
    staticClass: "form-group-min-height row py-3"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Email"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIntegration.email),
      expression: "currentIntegration.email"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.currentIntegration.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIntegration, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 py-2"
  }, [_c('label', {
    attrs: {
      "for": "stripeSecretKey"
    }
  }, [_vm._v("Integration Key")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIntegration.apiKey),
      expression: "currentIntegration.apiKey"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "stripeSecretKey",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.currentIntegration.apiKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIntegration, "apiKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pt-2",
    attrs: {
      "for": "stripePublicKey"
    }
  }, [_vm._v("Base Endpoint")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIntegration.baseUrl),
      expression: "currentIntegration.baseUrl"
    }],
    staticClass: "w-100",
    attrs: {
      "name": "stripePublicKey",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.currentIntegration.baseUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIntegration, "baseUrl", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('bottom-area', {
    attrs: {
      "isIntegrated": _vm.currentIntegration.integrationStatus == 1,
      "showConnectBtn": _vm.currentIntegration.integrationStatus == 0,
      "loadingConnectBtn": _vm.isOctoConnecting
    },
    on: {
      "disableIntegration": function($event) {
        return _vm.disableIntegration()
      },
      "connectIntegration": function($event) {
        return _vm.connect()
      },
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e8d2df7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/octoIntegrations.vue
// module id = 1994
// module chunks = 0